import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Grid, 
  Paper,
  Button,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Divider
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

// 导入图片
import collectionsBg from '../assets/images/collections/Bg.png';
import luopanImg from '../assets/images/collections/luopan.png';
import textImg from '../assets/images/collections/text01.png';

// 模拟收藏系列数据
const collections = [
  {
    id: 1,
    name: '紫晶系列',
    title: 'Amethyst Collection',
    image: 'https://via.placeholder.com/400x300?text=Amethyst',
    description: '紫晶是一种深受喜爱的宝石，拥有美丽的紫色色调，从淡紫色到深紫色不等，是石英家族的一部分。紫晶饰品有助于平静心灵和提高灵性意识，是冥想和精神成长的理想伴侣。',
    energy: '平静，保护，精神成长',
    link: '/shop'
  },
  {
    id: 2,
    name: '黑曜石系列',
    title: 'Obsidian Collection',
    image: 'https://via.placeholder.com/400x300?text=Obsidian',
    description: '黑曜石是一种天然形成的火山玻璃，深黑色表面带有亮光。在命理学中，黑曜石被视为强大的保护石，能够抵挡负能量，提供心灵屏障，并帮助持有者看清真相。',
    energy: '保护，真相，净化',
    link: '/shop'
  },
  {
    id: 3,
    name: '月光石系列',
    title: 'Moonstone Collection',
    image: 'https://via.placeholder.com/400x300?text=Moonstone',
    description: '月光石以其闪烁的蓝白色光泽而闻名，与月亮能量相连。它增强直觉，促进和谐与平衡，特别适合增强女性能量和促进温和的情感转变。',
    energy: '直觉，平衡，月亮能量',
    link: '/shop'
  },
  {
    id: 4,
    name: '青金石系列',
    title: 'Lapis Lazuli Collection',
    image: 'https://via.placeholder.com/400x300?text=Lapis+Lazuli',
    description: '青金石以其深蓝色和金色斑点（黄铁矿）而著称。在命理学中，青金石被视为智慧和真相的石头，有助于开阔思维，增强沟通能力，是学习和考试的理想支持。',
    energy: '智慧，真理，开阔思维',
    link: '/shop'
  },
  {
    id: 5,
    name: '粉晶系列',
    title: 'Rose Quartz Collection',
    image: 'https://via.placeholder.com/400x300?text=Rose+Quartz',
    description: '粉晶是一种温柔的粉红色石英，被称为"爱的石头"。它散发温和的能量，有助于促进自爱、情感治愈和吸引爱情，是增强人际关系的理想选择。',
    energy: '爱，情感治愈，和谐',
    link: '/shop'
  },
  {
    id: 6,
    name: '虎眼石系列',
    title: 'Tiger Eye Collection',
    image: 'https://via.placeholder.com/400x300?text=Tiger+Eye',
    description: '虎眼石以其金棕色外观和丝绢般的光泽而闻名。在命理学中，虎眼石被认为能带来勇气、自信和力量，有助于做出明智决定，尤其是在事业和财务方面。',
    energy: '勇气，决断力，保护',
    link: '/shop'
  }
];

const Collections = () => {
  return (
    <Box>
      {/* Hero Section */}
      <Box sx={{ position: 'relative', mb: 6 }}>
        <img 
          src={collectionsBg} 
          alt="Collections Background" 
          style={{ width: '100%', display: 'block' }}
        />
        <Box 
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            width: '100%',
            padding: '0 2rem',
            color: 'white'
          }}
        >
          <Typography variant="h3" fontWeight="bold" gutterBottom>
            水晶系列
          </Typography>
          <Typography variant="h5">
            Crystal Collections
          </Typography>
        </Box>
      </Box>

      {/* Introduction Section */}
      <Container maxWidth="lg" sx={{ mb: 8 }}>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h4" gutterBottom>
              水晶与命理
            </Typography>
            <Typography variant="h5" gutterBottom>
              Crystals & Destiny
            </Typography>
            <Divider sx={{ width: '60px', height: '4px', backgroundColor: '#9c27b0', mb: 3, borderRadius: '2px' }} />
            <Typography variant="body1" paragraph>
              在古老的命理学中，水晶被视为连接宇宙能量的媒介，每种水晶都拥有独特的频率和能量特性。我们精心挑选不同系列的水晶，帮助您平衡气场、增强特定能量、达成愿望。
            </Typography>
            <Typography variant="body1" paragraph>
              水晶不仅仅是美丽的装饰品，更是能量的载体。通过AI命理分析，我们能够推荐最适合您当前生命阶段和命理特质的水晶饰品，为您的生活增添和谐与力量。
            </Typography>
            <Typography variant="body1">
              每个系列都经过精心设计，将传统命理学智慧与现代珠宝工艺完美结合，创造出既美观又有能量意义的饰品。
            </Typography>
            <Button 
              variant="contained" 
              color="primary"
              component={RouterLink}
              to="/ai-fortune"
              sx={{ mt: 3 }}
            >
              获取个人水晶推荐
            </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box 
              component="img"
              src={luopanImg}
              alt="Luopan Compass"
              sx={{
                width: '100%',
                borderRadius: 2,
                boxShadow: '0 5px 15px rgba(0,0,0,0.1)'
              }}
            />
          </Grid>
        </Grid>
      </Container>

      {/* Collections Showcase */}
      <Box sx={{ bgcolor: '#f8f5fb', py: 8 }}>
        <Container maxWidth="lg">
          <Typography variant="h4" align="center" gutterBottom>
            我们的水晶系列
          </Typography>
          <Typography variant="h5" align="center" gutterBottom>
            Our Crystal Collections
          </Typography>
          <Divider sx={{ width: '60px', height: '4px', backgroundColor: '#9c27b0', mb: 5, mx: 'auto', borderRadius: '2px' }} />
          
          <Grid container spacing={4}>
            {collections.map((collection) => (
              <Grid item xs={12} sm={6} md={4} key={collection.id}>
                <Card 
                  sx={{ 
                    height: '100%', 
                    display: 'flex', 
                    flexDirection: 'column',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      boxShadow: '0 10px 20px rgba(0,0,0,0.1)'
                    }
                  }}
                >
                  <CardMedia
                    component="img"
                    height="200"
                    image={collection.image}
                    alt={collection.name}
                  />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography variant="h5" gutterBottom>
                      {collection.name}
                    </Typography>
                    <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                      {collection.title}
                    </Typography>
                    <Typography variant="body2" paragraph>
                      {collection.description}
                    </Typography>
                    <Box 
                      sx={{ 
                        bgcolor: 'rgba(156, 39, 176, 0.1)', 
                        p: 1.5, 
                        borderRadius: 1,
                        mt: 1
                      }}
                    >
                      <Typography variant="subtitle2" color="primary">
                        能量属性：{collection.energy}
                      </Typography>
                    </Box>
                  </CardContent>
                  <CardActions sx={{ p: 2 }}>
                    <Button 
                      variant="outlined" 
                      color="primary" 
                      component={RouterLink}
                      to={collection.link}
                      fullWidth
                    >
                      浏览系列
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Destiny Connection */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={6} alignItems="center" direction={{ xs: 'column-reverse', md: 'row' }}>
          <Grid item xs={12} md={6}>
            <Box 
              component="img"
              src={textImg}
              alt="Destiny Text"
              sx={{
                width: '100%',
                borderRadius: 2
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h4" gutterBottom>
              如何选择适合的水晶
            </Typography>
            <Typography variant="h5" gutterBottom>
              How to Choose Your Crystal
            </Typography>
            <Divider sx={{ width: '60px', height: '4px', backgroundColor: '#9c27b0', mb: 3, borderRadius: '2px' }} />
            <Typography variant="body1" paragraph>
              选择水晶不仅仅是外观和喜好的问题，更应该基于个人的命理特质和当前的生活需求。每个人的八字和命盘都有其独特之处，需要不同的能量来平衡和增强。
            </Typography>
            <Typography variant="body1" paragraph>
              我们的AI算命服务能够分析您的生辰八字，了解您的五行属性和能量状态，并推荐最适合您的水晶系列。这种个性化的推荐可以帮助您在正确的时间获得正确的能量支持。
            </Typography>
            <Typography variant="body1" paragraph>
              您也可以根据直觉选择——当某颗水晶特别吸引您时，这可能是因为您的能量场正需要它所提供的特质。倾听内心的声音，选择让您感到和谐与平静的水晶。
            </Typography>
            <Button 
              variant="contained" 
              color="primary"
              component={RouterLink}
              to="/shop"
              sx={{ mt: 2 }}
            >
              探索所有水晶产品
            </Button>
          </Grid>
        </Grid>
      </Container>

      {/* Call to Action */}
      <Box sx={{ bgcolor: '#9c27b0', color: 'white', py: 8, textAlign: 'center' }}>
        <Container maxWidth="md">
          <Typography variant="h4" gutterBottom>
            发现您的命定水晶
          </Typography>
          <Typography variant="body1" paragraph sx={{ mb: 4 }}>
            每个人都有与生俱来的命理特质，我们的AI命理系统能帮您找到最适合的水晶伴侣。
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
            <Button 
              variant="contained" 
              color="secondary"
              sx={{ px: 4, py: 1.5, fontSize: '1rem' }}
              component={RouterLink}
              to="/ai-fortune"
            >
              免费命理分析
            </Button>
            <Button 
              variant="outlined" 
              sx={{ 
                px: 4, 
                py: 1.5, 
                fontSize: '1rem', 
                borderColor: 'white', 
                color: 'white',
                '&:hover': {
                  borderColor: 'white',
                  backgroundColor: 'rgba(255,255,255,0.1)'
                }
              }}
              component={RouterLink}
              to="/shop"
            >
              浏览全部水晶
            </Button>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Collections;